import { scrolledPage } from './utils'

export default (): void => {
  const header = document.querySelector('*[data-header]') as HTMLElement

  if (!header) return

  const scrollHeader = (): void => {
    const currentOffsetTop: number = scrolledPage().top

    header.dataset.header = header.offsetHeight < currentOffsetTop ? 'active' : ''
  }

  scrollHeader()
  document.addEventListener('scroll', scrollHeader as EventListener)
}
